// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__278ft","title":"Info_title__3RfEo","links":"Info_links__qQkzi","link":"Info_link__2AyVN","logo":"Info_logo__Q9p6z"};